import { Node } from '../Node';

export const Image = Node.create({
  name: 'image',
  nodeType: 'img',
  group: 'block',
  draggable: true,
});
